// eslint-disable-next-line no-restricted-imports
import { useTheme } from '@emotion/react';
import {
  Box,
  Button,
  ErrorIcon,
  Flex,
  Loading,
  Typography,
} from '@iheartjane/reefer';
import { QRCode } from 'react-qrcode-logo';

import { useKioskSpacing } from '../../../hooks';

const qrWidth = 240;

const getTextAndSubtext = (type: 'jane-gold' | 'link-bank' | 'login') => {
  switch (type) {
    case 'jane-gold':
      return {
        text: 'Learn more about Jane Gold rewards',
        subtext:
          'Scan the QR code to learn more about how Jane Gold could help you get the best price.',
      };
    case 'link-bank':
      return {
        text: 'Scan the QR code with your phone to link your bank account',
        subtext: undefined,
      };
    case 'login':
      return {
        text: 'Scan the QR code and use your phone to sign in',
        subtext:
          'You are logging onto a shared device. To protect your privacy, the kiosk will automatically sign you out after a period of inactivity. You can also sign out manually at any time.',
      };
  }
};

export const QRCodeCallout = ({
  buttonLabel,
  onClick,
  qrCode,
  type,
  url,
  error,
}: {
  buttonLabel: string;
  error?: string | null;
  onClick: () => void;
  qrCode: string;
  type: 'jane-gold' | 'link-bank' | 'login';
  url?: string;
}) => {
  const { colors } = useTheme();
  const { defaultSpacing, isIpad, getKioskSpacing } = useKioskSpacing();
  const { text, subtext } = getTextAndSubtext(type);

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      m={getKioskSpacing(32, 40)}
      width="432px"
    >
      {error ? (
        <>
          <Box p={24} ariaLabel="Error Icon">
            <ErrorIcon color="error-dark" size="xl" />
          </Box>
          <Typography
            variant="title-bold"
            textAlign="center"
            mt={defaultSpacing}
          >
            Something went wrong
          </Typography>
          <Typography textAlign="center" mt={getKioskSpacing(24, 8)}>
            {error}
          </Typography>
        </>
      ) : (
        <>
          <Box p={24} ariaLabel="QR Code">
            {url ? (
              <QRCode
                id={`mobile-${type}-qr`}
                fgColor={colors.grays.black}
                logoImage={qrCode}
                logoWidth={qrWidth * 0.3}
                size={qrWidth}
                value={url}
              />
            ) : (
              <Box position="relative" mt={24}>
                <Loading size="lg" />
              </Box>
            )}
          </Box>
          <Typography
            variant="title-bold"
            textAlign="center"
            mt={defaultSpacing}
          >
            {text}
          </Typography>
          {subtext && (
            <Typography textAlign="center" mt={getKioskSpacing(24, 8)}>
              {subtext}
            </Typography>
          )}
        </>
      )}
      <Button
        mt={defaultSpacing}
        label={
          isIpad ? (
            buttonLabel
          ) : (
            <Typography color="text-info" variant="section-bold" as="p">
              {buttonLabel}
            </Typography>
          )
        }
        onClick={onClick}
        full
        branded
        size={isIpad ? 'small' : 'large'}
      />
    </Flex>
  );
};
